const STORAGE_KEY = "engagement_category_nudges";

/**
 * Get all dismissed nudge IDs from sessionStorage
 */
function getDismissedNudges() {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch (e) {
    console.error("Error reading nudge dismissals:", e);
    return [];
  }
}

/**
 * Save dismissed nudge IDs to sessionStorage
 */
function saveDismissedNudges(dismissals) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(dismissals));
  } catch (e) {
    console.error("Error saving nudge dismissals:", e);
  }
}

/**
 * Check if a nudge was dismissed in this session
 * @param {string} type - 'prompt' or 'guide'
 * @param {string} id - The prompt or guide ID
 * @returns {boolean} - True if nudge was dismissed in this browser session
 */
export function wasNudgeDismissed(type, id) {
  const dismissals = getDismissedNudges();
  const key = `${type}_${id}`;
  return dismissals.includes(key);
}

/**
 * Mark a nudge as dismissed for this browser session
 * @param {string} type - 'prompt' or 'guide'
 * @param {string} id - The prompt or guide ID
 */
export function markNudgeDismissed(type, id) {
  const dismissals = getDismissedNudges();
  const key = `${type}_${id}`;
  if (!dismissals.includes(key)) {
    dismissals.push(key);
    saveDismissedNudges(dismissals);
  }
}

/**
 * Clear a specific nudge dismissal (e.g., when user successfully saves)
 * @param {string} type - 'prompt' or 'guide'
 * @param {string} id - The prompt or guide ID
 */
export function clearNudgeDismissal(type, id) {
  const dismissals = getDismissedNudges();
  const key = `${type}_${id}`;
  const filtered = dismissals.filter(item => item !== key);
  saveDismissedNudges(filtered);
}

/**
 * Check if engagement category nudge should be shown for an item
 * @param {Object} app - The app object with flags
 * @param {Object} item - The prompt or guide object
 * @param {string} type - 'prompt' or 'guide'
 * @returns {boolean} - True if nudge should be shown
 */
export function shouldShowEngagementCategoryNudge(app, item, type) {
  if (!app?.flags?.enable_engagement_category_nudge_on_update) return false;
  if (item?.engagement_category) return false;
  if (!item?.id) return false;
  if (wasNudgeDismissed(type, item.id)) return false;

  return true;
}
